<template>
  <fragment v-if="!data.hidden && !hideMap[data.name]">
    <template v-if="data.meta.onlyMode">
      <el-submenu
        v-if="data.hasOwnProperty('children') && data.children.length > 0 && !hasOlnyChildren(data)"
        :index="data.meta.guid"
        popper-append-to-body
      >
        <template slot="title">
          <i
            v-if="data.meta.icon && data.meta.icon.length > 0"
            :class="data.meta.icon"
            :style="{ color: textColor }"
          />
          <span>{{ data.meta.title }}</span>
        </template>
        <subMenu-item v-for="(obj, j) in data.children" :key="j" :data="obj" :text-color="textColor" />
      </el-submenu>
      <el-menu-item v-else-if="hasOlnyChildren(data)" :index="olnyChildren.meta.guid">
        <i
          v-if="olnyChildren.meta.icon && olnyChildren.meta.icon.length > 0"
          :class="olnyChildren.meta.icon"
          :style="{ color: textColor }"
        />
        <span slot="title">{{ olnyChildren.meta.title }}</span>
      </el-menu-item>
      <el-menu-item v-else :index="data.meta.guid">
        <i v-if="data.meta.icon && data.meta.icon.length > 0" :class="data.meta.icon" :style="{ color: textColor }" />
        <span slot="title">{{ data.meta.title }}</span>
      </el-menu-item>
    </template>
    <template v-else>
      <el-submenu v-if="data.hasOwnProperty('children')" :index="data.meta.guid" popper-append-to-body>
        <template slot="title">
          <i
            v-if="data.meta.icon && data.meta.icon.length > 0"
            :class="data.meta.icon"
            :style="{ color: textColor }"
          />
          <span>{{ data.meta.title }}</span>
        </template>
        <subMenu-item v-for="(obj, j) in data.children" :key="j" :data="obj" :text-color="textColor" />
      </el-submenu>
      <el-menu-item v-else :index="data.meta.guid">
        <i v-if="data.meta.icon && data.meta.icon.length > 0" :class="data.meta.icon" :style="{ color: textColor }" />
        <span slot="title">
          {{ data.meta.title }}
          <el-tag v-if="badge[data.name] !== undefined" class="ml-2" type="success" size="mini" effect="dark">{{ badge[data.name] }}</el-tag>
        </span>
      </el-menu-item>
    </template>
  </fragment>
</template>

<script>
/**
 * 动态菜单
 */
export default {
  name: 'SubMenuItem',
  props: {
    textColor: {
      type: String,
      default() {
        // return '#4d5259'
        return 'inherit'
      }
    },
    data: {
      type: Object,
      require: true,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },

  computed: {
    badge() {
      return this.$store.state.routes.badge
    },

    hideMap() {
      return this.$store.state.routes.hideMap || {}
    }
  },

  methods: {
    hasOlnyChildren(data) {
      if (data && data.children && data.children.length > 0 && !data.alwaysShow) {
        var res = data.children.filter((el) => {
          return !el.hidden
        })
        if (res && res.length === 1) {
          this.olnyChildren = JSON.parse(JSON.stringify(res[0]))
          return true
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
:deep() {
  .el-submenu__title {
    .el-icon-arrow-down {
      color: inherit;
      font-size: 18px;
    }
  }
}
::v-deep {

}
</style>

<style lang="scss">
  .el-submenu__title .iconfont {
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
    line-height: 1;
  }
  .el-menu-item .iconfont {
    display: inline-block;
    vertical-align: middle;
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
    line-height: 1;
  }
</style>
